import service from '@/store/services/biotimes/biotime-attendances-service';

const state = {
    list: [],
    attendance: null,
    meta: {},
    statistics: {},
    todayStats: {},
    isLoading: false,
    error: null
};

const mutations = {
    SET_LIST(state, list) {
        state.list = list;
    },
    SET_RESOURCE(state, attendance) {
        state.attendance = attendance;
    },
    SET_META(state, meta) {
        state.meta = meta;
    },
    SET_STATISTICS(state, statistics) {
        state.statistics = statistics;
    },
    SET_TODAY_STATS(state, todayStats) {
        state.todayStats = todayStats;
    },
    SET_LOADING(state, status) {
        state.isLoading = status;
    },
    SET_ERROR(state, error) {
        state.error = error;
    }
};

const actions = {
    list({ commit }, params = {}) {
        commit('SET_LOADING', true);
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
                commit('SET_LOADING', false);
                return { list, meta };
            })
            .catch(error => {
                commit('SET_LOADING', false);
                commit('SET_ERROR', error.message);
                throw error;
            });
    },

    get({ commit }, id) {
        commit('SET_LOADING', true);
        return service.get(id)
            .then(attendance => {
                commit('SET_RESOURCE', attendance);
                commit('SET_LOADING', false);
                return attendance;
            })
            .catch(error => {
                commit('SET_LOADING', false);
                commit('SET_ERROR', error.message);
                throw error;
            });
    },

    view({ commit }, params) {
        commit('SET_LOADING', true);
        return service.view(params)
            .then(attendance => {
                commit('SET_RESOURCE', attendance);
                commit('SET_LOADING', false);
                return attendance;
            })
            .catch(error => {
                commit('SET_LOADING', false);
                commit('SET_ERROR', error.message);
                throw error;
            });
    },

    getStatistics({ commit }, params = {}) {
        commit('SET_LOADING', true);
        return service.getStatistics(params)
            .then(statistics => {
                commit('SET_STATISTICS', statistics);
                commit('SET_LOADING', false);
                return statistics;
            })
            .catch(error => {
                commit('SET_LOADING', false);
                commit('SET_ERROR', error.message);
                throw error;
            });
    },

    getTodayStats({ commit }, params = {}) {
        commit('SET_LOADING', true);
        return service.getTodayStats(params)
            .then(todayStats => {
                commit('SET_TODAY_STATS', todayStats);
                commit('SET_LOADING', false);
                return todayStats;
            })
            .catch(error => {
                commit('SET_LOADING', false);
                commit('SET_ERROR', error.message);
                throw error;
            });
    },
    processAttendances({ commit }, payload) {
        commit('SET_LOADING', true);
        return service.processAttendances(payload)
            .then(result => {
                commit('SET_LOADING', false);
                return result;
            })
            .catch(error => {
                commit('SET_LOADING', false);
                commit('SET_ERROR', error.message);
                throw error;
            });
    },

    clearError({ commit }) {
        commit('SET_ERROR', null);
    }
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    meta: state => state.meta,
    attendance: state => state.attendance,
    statistics: state => state.statistics,
    todayStats: state => state.todayStats,
    isLoading: state => state.isLoading,
    error: state => state.error
};

const biotimeAttendances = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default biotimeAttendances;